/* Rolvea 09/10/2026 — mega menu «elenco con anteprima».
   FLAG: ACCESO per tutti dal 09/10/2026 (ON_BY_DEFAULT = true). Per spegnerlo a tutti: ON_BY_DEFAULT = false
   (allora si vede solo con ?mm=1). ?mm=0 lo spegne solo nel proprio browser. Il drawer classico non viene toccato. */
(function () {
  'use strict';
  var ON_BY_DEFAULT = true;
  var KEY = 'rlv_mm';
  var on = ON_BY_DEFAULT;
  try {
    var q = new URLSearchParams(location.search).get('mm');
    if (q === '1') localStorage.setItem(KEY, '1');
    else if (q === '0') localStorage.setItem(KEY, '0');
    var v = localStorage.getItem(KEY);
    if (v === '1') on = true; else if (v === '0') on = false;
  } catch (e) {}
  if (!on) return;

  /* foto per voce di menu (handle della collezione -> chiave foto) */
  var B = 'https://cdn.shopify.com/s/files/1/0911/5883/9671/files/';
  var IMG = {
    costumi: B + 'pdp_hero_3q_front_08262aae-afb2-40c5-848c-2ea1b5c8ccf0.jpg',
    bikini: B + 'pdp_hero_3q_front_67bd672d-353f-431c-89ab-2541555398c1.jpg',
    interi: B + 'caramel_nero_pdp_hero_3q_back.jpg',
    copri: B + '4BKkRKCQ8O4htjU.webp',
    active: B + '3003-leggings-nero-02_e9bae237-8836-443b-980d-5c87bdfd5ce9.jpg',
    activeNew: B + 'H61110b40392a44b695403afe04281440E_6427d785-40ed-44d9-9754-640797f73467.webp',
    setc: B + 'H61110b40392a44b695403afe04281440E_6427d785-40ed-44d9-9754-640797f73467.webp',
    classic: B + '3003-leggings-nero-02_e9bae237-8836-443b-980d-5c87bdfd5ce9.jpg',
    edge: B + 'edge-nero-hero.jpg',
    leggings: B + '3003-leggings-nero-02_e9bae237-8836-443b-980d-5c87bdfd5ce9.jpg',
    short: B + '3006-bs-nero-pack_ce66e4ab-5845-4d70-8ece-e411f8f54079.jpg',
    sportbra: B + '3003-BR-AG.jpg',
    canotte: B + 'Ha3cbf9e493fc46679538db0e2d4d9196m.webp',
    giacche: B + 'H4e008add504d462d8b1f66e12f4347f3d.webp',
    pantaloni: B + 'H20216327ead44bee8e13ee2fca9784b9S_2af603fb-aee6-415f-8c18-3bdda4f3700c.webp',
    body: B + 'Hd417c71a36724af48236d147dfd9e4beI.webp',
    setcat: B + 'H61110b40392a44b695403afe04281440E_6427d785-40ed-44d9-9754-640797f73467.webp',
    seconda: B + '3003-leggings-nero-02_e9bae237-8836-443b-980d-5c87bdfd5ce9.jpg',
    costa: B + '8022-GZ-DG_7f1b592e-5506-49ac-bec8-7a153040cecb.jpg',
    intimo: B + 'rv-pl-slip-01.jpg',
    slip: B + 'rv-pl-vita-alta-slip-01.jpg',
    tanga: B + 'rv-pl-tanga-inv-03.jpg',
    bra: B + 'rv-bra-nero.jpg',
    collant: B + 'rv-collant-01-hero.jpg',
    uomo: B + '6612-1.jpg',
    tshirt: B + '4304-2.jpg',
    gioielli: B + 'S02a937e052aa4c1b84b5b040b0ad931e7.webp',
    crema: B + '2_031b836e-dc0c-4f95-9985-77aefad6eb86.png'
  };
  var MAP = {
    'costumi-abbronzanti':'costumi','bikini-abbronzanti':'bikini','costumi-interi':'interi','copricostumi':'copri',
    'modelli-tutto':'active','new-in':'activeNew','set-coordinati':'setc','sculptline-classic':'classic','sculptline-edge':'edge',
    'modelli-leggings':'leggings','modelli-short':'short','modelli-reggiseni':'sportbra','modelli-canotte':'canotte',
    'modelli-giacche':'giacche','modelli-pantaloni':'pantaloni','modelli-body-tute':'body','modelli-set':'setcat',
    'seconda-pelle':'seconda','costa':'costa','collezione-completa':'seconda',
    'pureline-intimo':'intimo','pureline-reggiseni':'bra','pureline-slip':'slip','pureline-tanga':'tanga','collant-termici':'collant',
    'costumi-uomo':'uomo','t-shirt':'tshirt','gioielli':'gioielli','crema-abbronzante-shrinebrown':'crema'
  };
  var COLORS = {
    'colore-nero':'#1a1a1a','colore-marrone':'#6b4a3a','colore-bianco':'#efe6d6','colore-blu':'#3a63b5','colore-grigio':'#9b9ea3',
    'colore-rosso':'#c1272d','colore-bordeaux':'#6d1f2f','colore-rosa':'#e9a4b8','colore-verde':'#4e8a5a','colore-giallo':'#e8c93c',
    'colore-arancione':'#ea8640','colore-viola':'#7a55a6'
  };
  function src(h, w) { var k = MAP[h]; var u = k && IMG[k]; return u ? u + '?width=' + (w || 480) : ''; }

  var root = document.getElementById('RlvMM');
  if (!root) return;
  document.body.appendChild(root); /* fuori dall'header: niente problemi con position:fixed dentro l'header sticky */

  var mq = window.matchMedia('(min-width:990px)');
  var title = root.querySelector('[data-mm-title]');
  var cats = [].slice.call(root.querySelectorAll('[data-mm-cat]'));
  var panes = [].slice.call(root.querySelectorAll('[data-mm-pane]'));
  var hydrated = false;

  function paneOf(idx) { for (var i = 0; i < panes.length; i++) if (panes[i].getAttribute('data-mm-pane') === String(idx)) return panes[i]; return null; }
  function setPreview(pane, h, label, href) {
    var pv = pane.querySelector('.rlv-mm__pv'); if (!pv) return;
    var img = pv.querySelector('img'), a = pv.querySelector('.rlv-mm__pva'), b = pv.querySelector('b');
    var s = src(h, 760);
    if (s && img.getAttribute('src') !== s) img.setAttribute('src', s);
    if (label && !pane.classList.contains('rlv-mm__pane--solo')) b.textContent = label;
    if (href) a.setAttribute('href', href);
  }
  function highlight(pane, row) {
    [].forEach.call(pane.querySelectorAll('.rlv-mm__row'), function (r) { r.classList.toggle('is-on', r === row); });
  }
  function select(idx) {
    cats.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-mm-cat') === String(idx)); });
    panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-mm-pane') === String(idx)); });
    var p = paneOf(idx);
    if (p) {
      var first = p.querySelector('.rlv-mm__row');
      if (first && !p.classList.contains('rlv-mm__pane--solo')) { highlight(p, first); setPreview(p, first.getAttribute('data-h'), first.getAttribute('data-t'), first.getAttribute('href')); }
      else if (p.classList.contains('rlv-mm__pane--solo')) { setPreview(p, first && first.getAttribute('data-h')); }
    }
    return p;
  }
  function hydrate() {
    if (hydrated) return; hydrated = true;
    [].forEach.call(root.querySelectorAll('[data-mm-thumb]'), function (t) {
      var h = t.parentNode.getAttribute('data-h'); var s = src(h, 160);
      if (s) { var im = new Image(); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.src = s; t.appendChild(im); }
    });
    [].forEach.call(root.querySelectorAll('.rlv-mm__banner'), function (b) {
      var s = src(b.getAttribute('data-h'), 800); if (s) b.style.backgroundImage = 'url(' + s + ')';
    });
    [].forEach.call(root.querySelectorAll('.rlv-mm__dot'), function (d) {
      var c = COLORS[d.getAttribute('data-h')]; if (c) d.firstElementChild.style.background = c;
    });
  }
  function setState(st, label) {
    root.setAttribute('data-mm-state', st);
    title.textContent = st === 'pane' && label ? label : title.getAttribute('data-t-menu');
  }
  function open() {
    hydrate();
    var hw = document.querySelector('.header-wrapper, sticky-header, .section-header');
    var top = hw ? Math.max(0, Math.round(hw.getBoundingClientRect().bottom)) : 0;
    root.style.setProperty('--rlv-mm-top', top + 'px');
    root.hidden = false;
    document.documentElement.classList.add('rlv-mm-lock');
    setState('cats');
    if (mq.matches) { var first = cats.filter(function (c) { return !c.hasAttribute('data-mm-solo'); })[0] || cats[0]; if (first) select(first.getAttribute('data-mm-cat')); }
    else { cats.forEach(function (c) { c.classList.remove('is-on'); }); panes.forEach(function (p) { p.classList.remove('is-on'); }); }
    document.dispatchEvent(new CustomEvent('rlv-mm:open'));
  }
  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('rlv-mm-lock');
  }
  function toggle() { if (root.hidden) open(); else close(); }

  /* il pulsante hamburger apre il nuovo pannello al posto del drawer classico */
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('summary.header__icon--menu');
    if (s && !root.contains(s)) { e.preventDefault(); e.stopPropagation(); toggle(); }
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mm-close]')) { e.preventDefault(); close(); return; }
    if (t.closest('[data-mm-back]')) { e.preventDefault(); setState('cats'); return; }
    var cat = t.closest('[data-mm-cat]');
    if (cat && !cat.hasAttribute('data-mm-solo')) {
      e.preventDefault();
      var p = select(cat.getAttribute('data-mm-cat'));
      if (!mq.matches && p) setState('pane', p.getAttribute('data-title'));
    }
  });
  /* desktop: passando sopra una categoria cambia l'elenco, passando sopra una voce cambia la foto */
  root.addEventListener('mouseover', function (e) {
    if (!mq.matches) return;
    var cat = e.target.closest('[data-mm-cat]');
    if (cat) { if (!cat.classList.contains('is-on')) select(cat.getAttribute('data-mm-cat')); return; }
    var item = e.target.closest('.rlv-mm__row, .rlv-mm__chip, .rlv-mm__dot');
    if (!item) return;
    var pane = item.closest('.rlv-mm__pane'); if (!pane || pane.classList.contains('rlv-mm__pane--solo')) return;
    if (item.classList.contains('rlv-mm__dot')) return;
    if (item.classList.contains('rlv-mm__row')) highlight(pane, item);
    setPreview(pane, item.getAttribute('data-h'), item.getAttribute('data-t'), item.getAttribute('href'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  mq.addEventListener && mq.addEventListener('change', function () { if (!root.hidden) open(); });
})();
